<template>
    <div>
        <ToolBar :menu="'Tài khoản'" :content="'Lịch sử đăng nhập'">
            <template v-slot:form>
                <CustomButton
                    label="Tìm kiếm"
                    @click="handleSearch"
                    :btnToolBar="true"
                />
            </template>
        </ToolBar>
        <FormSearch :column-form="1">
            <div class="row">
                <div class="col-md-6 mt-2 d-flex align-items-center">
                    <div class="flex-grow-1">
                        <CustomDatePicker
                            :placeholderText="'Ngày bắt đầu'"
                            v-model="start_time"
                        />
                    </div>

                    <div class="to-date">Đến</div>

                    <div class="flex-grow-1">
                        <CustomDatePicker
                            :placeholderText="'Ngày kết thúc'"
                            v-model="end_time"
                        />
                    </div>
                </div>
            </div>
        </FormSearch>
        <CustomTable :column-form="1" :hide-btn-table="true">
            <template v-slot:header>
                <tr>
                    <th>STT</th>
                    <th>Tài khoản</th>
                    <th>Trạng thái</th>
                    <th>Thời gian</th>
                </tr>
            </template>
            <template v-slot:body>
                <template v-if="tableData.length === 0">
                    <tr>
                        <td colspan="6">Không có bản ghi nào.</td>
                    </tr>
                </template>
                <tr v-for="(item, index) in tableData" :key="index">
                    <td>
                        {{ (currentPage - 1) * limit + index + 1 }}
                    </td>
                    <td>
                        {{ item.username }}
                    </td>
                    <td class="text-left">
                        {{ item.responseMessage }}
                    </td>

                    <td>
                        {{ item.loginTimeString }}
                    </td>
                </tr>
            </template>
            <template v-slot:pagi>
                <CustomPagination
                    v-show="total_rows > 0"
                    :tongbanghi="total_rows"
                    :pageSize="pageSize"
                    :pageStart="pageStart"
                    @pageChange="pageChange($event)"
                    @pageSizeChange="pageSizeChange($event)"
                >
                </CustomPagination>
            </template>
        </CustomTable>
    </div>
</template>

<script>
import FormSearch from '@/components/FormSearch.vue'
import ToolBar from '@/components/ToolBar.vue'
import CustomButton from '@/components/CustomButton.vue'
import { getFromSessionStorage } from '@/utils/session'
import { hideLoading, showLoading } from '@/utils/loading'
import sendRequest from '@/services'
import Api from '@/constants/Api'
import { defaultToastConfig, formatDateToDDMMYYYY } from '@/utils'
import CustomTable from '@/components/CustomTable.vue'
import CustomPagination from '@/components/CustomPagination.vue'
import CustomDatePicker from '@/components/CustomDatePicker.vue'
export default {
    name: 'LoginHistory',
    components: {
        FormSearch,
        ToolBar,
        CustomButton,

        CustomTable,
        CustomDatePicker,
        CustomPagination
    },
    data() {
        return {
            start: 0,
            total_rows: 0,
            currentPage: 1,
            limit: 25,
            pageSize: 25,
            pageStart: false,

            start_time: '',
            end_time: '',

            tableData: []
        }
    },

    methods: {
        pageSizeChange(e) {
            this.total_rows = 0
            this.pageSize = e.soluong
        },
        checkTruocKhiTim() {
            this.pageStart = !this.pageStart
        },
        pageChange(e) {
            this.start = e.start
            this.limit = e.limit
            this.currentPage = e.currentPage
            this.handleSearch()
        },

        async handleSearch() {
            try {
                showLoading()

                const request_data = {
                    username: this.auth_user.username,
                    startTime: formatDateToDDMMYYYY(this.start_time),
                    endTime: formatDateToDDMMYYYY(this.end_time),
                    start: this.start,
                    limit: this.limit
                }
                const response = await sendRequest(
                    Api.tai_khoan.lich_su_dang_nhap,
                    request_data,
                    this.request_headers
                )

                this.tableData = response.data
                this.total_rows = response.total
                hideLoading()
            } catch (error) {
                hideLoading()
            }
        }
    },
    mounted() {
        this.handleSearch()
    },

    computed: {
        selectedYearFromStore() {
            return this.$store.state.selectedYear.selectedYear
        },

        auth_user() {
            return getFromSessionStorage('auth_user')
        },
        request_headers() {
            return {
                token: this.auth_user.token
            }
        }
    }
}
</script>

<style scoped>
.to-date {
    padding: 11px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
}
@media only screen and (max-width: 767px) {
    .col-md-2 {
        margin-top: 20px;
    }
}
</style>
